import Link from 'next/link'
import cx from 'classnames'
import DealsDatabaseIcon from '../assets/DealsDatabaseIcon'
import Container from './Container'

import { useRouter } from 'next/router'
import { MenuOption } from '../types'

type MenuProps = {
  className?: string
  options: Array<MenuOption>
  currentPath: string
}

function Menu(props: MenuProps) {
  const { className, options, currentPath } = props

  const router = useRouter()

  function onSearch() {
    router.push('/search')
    document.getElementById('search-input')?.focus()
  }

  return (
    <div className={cx('menu-wrapper', className)}>
      <Container>
        <div className="menu">
          <Link href="/deals-database">
            <a className="menu-item left">
              <DealsDatabaseIcon />
              <span className="ml-2">{`Deals Database`}</span>
            </a>
          </Link>
          {options.map((option) => (
            <Link href={option.url} key={option.title}>
              <a
                target={option.target || '_self'}
                className={cx(
                  'menu-item',
                  currentPath === option.url ? 'active' : null
                )}
              >
                {option.title}
              </a>
            </Link>
          ))}
          <button
            onClick={onSearch}
            className={cx('menu-item', currentPath === '/search' && 'active')}
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4301 13.495L17.8851 16.6988C18.0365 16.8395 18.0385 17.0699 17.8897 17.2129C17.7409 17.3561 17.4974 17.3579 17.346 17.2172L13.8696 13.9936C12.5066 15.0913 10.7396 15.7538 8.80913 15.7538C4.4967 15.7538 1 12.4487 1 8.37125C1 6.33247 1.87413 4.48649 3.28733 3.15049C6.31955 0.283194 11.2981 0.283106 14.3303 3.15061C17.3242 5.98117 17.3683 10.6141 14.4302 13.4949L14.4301 13.495ZM8.80871 15.0245C10.7518 15.0245 12.5114 14.2797 13.7846 13.0759C16.5174 10.4922 16.5177 6.25023 13.7848 3.66613C11.0523 1.08221 6.56471 1.08233 3.83215 3.66613C2.55878 4.87005 1.77116 6.53363 1.77116 8.37118C1.77116 12.046 4.92193 15.0243 8.80874 15.0243L8.80871 15.0245Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4309 13.4942C14.4307 13.4944 14.4305 13.4946 14.4302 13.4949L17.8851 16.6988C18.0365 16.8395 18.0385 17.0699 17.8897 17.2129C17.7513 17.3461 17.5309 17.3569 17.379 17.2446C17.3792 17.2448 17.3788 17.2445 17.379 17.2446C17.3677 17.2363 17.3564 17.2269 17.346 17.2172L13.8696 13.9936C13.8688 13.9943 13.8679 13.995 13.867 13.9957C12.5044 15.0922 10.7383 15.7538 8.80913 15.7538C8.52605 15.7538 8.24608 15.7396 7.97079 15.7118C6.09585 15.5226 4.41915 14.706 3.18028 13.4883C1.83013 12.1613 1 10.358 1 8.37125C1 6.38924 1.82613 4.58943 3.17055 3.26326C3.20906 3.22528 3.24798 3.18769 3.28733 3.15049C3.29741 3.14096 3.30751 3.13146 3.31763 3.12199C3.31762 3.122 3.31764 3.12198 3.31763 3.12199C6.34238 0.292849 11.2748 0.292618 14.2996 3.12172C14.2996 3.12172 14.2996 3.12173 14.2996 3.12172C14.3099 3.13131 14.3201 3.14095 14.3303 3.15061C14.3532 3.17227 14.376 3.19404 14.3985 3.21592C17.1517 5.88434 17.3332 10.1003 14.9165 12.9705C14.7653 13.1501 14.604 13.3244 14.4324 13.4927C14.4319 13.4932 14.4314 13.4937 14.4309 13.4942ZM15.4895 13.4545C18.1807 10.26 17.9552 5.54568 14.8456 2.60569C11.5243 -0.535264 6.09337 -0.535148 2.77202 2.60555C1.22017 4.07263 0.25 6.11133 0.25 8.37125C0.25 12.9021 4.12278 16.5038 8.80913 16.5038C10.6749 16.5038 12.4061 15.9356 13.8166 14.9673L16.8355 17.7667C17.2774 18.1772 17.9731 18.1733 18.4095 17.7536M15.4895 13.4545L18.3951 16.1489C18.8619 16.5825 18.8688 17.3117 18.4095 17.7536M3.83215 3.66613C3.82208 3.67566 3.81203 3.68521 3.80202 3.69479C3.80204 3.69477 3.802 3.69481 3.80202 3.69479C3.76718 3.72813 3.73264 3.76189 3.69854 3.79592C2.50391 4.98824 1.77116 6.59879 1.77116 8.37118C1.77116 10.1503 2.50967 11.7662 3.71268 12.9598C4.83234 14.0708 6.35437 14.8161 8.05784 14.9869C8.304 15.0116 8.55394 15.0242 8.80701 15.0243C8.80759 15.0243 8.80816 15.0243 8.80874 15.0243C8.8086 15.0243 8.80888 15.0243 8.80874 15.0243C8.80917 15.0243 8.81 15.0245 8.81043 15.0245C9.06661 15.0244 9.3196 15.0114 9.56871 14.9861C11.0255 14.8382 12.3494 14.27 13.4015 13.4123C13.45 13.3728 13.498 13.3326 13.5454 13.2918C13.6269 13.2216 13.7067 13.1496 13.7846 13.0759C16.487 10.5209 16.5174 6.34421 13.8748 3.7528C13.8552 3.73352 13.8354 3.71433 13.8154 3.69522C13.8154 3.69524 13.8154 3.6952 13.8154 3.69522C13.8053 3.68552 13.795 3.67578 13.7848 3.66613C11.0523 1.08221 6.56471 1.08233 3.83215 3.66613ZM8.86158 14.2743C10.5901 14.261 12.1455 13.5935 13.2693 12.531C15.6891 10.2431 15.6894 6.49925 13.2695 4.21109C10.8262 1.90059 6.79089 1.90066 4.34744 4.21109C3.21275 5.28389 2.52116 6.75471 2.52116 8.37118C2.52116 11.5926 5.29587 14.2743 8.80874 14.2743H8.86158Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </Container>
      <style jsx>{`
        .menu-wrapper {
          @apply min-h-[6px] bg-black text-white;
        }
        .menu {
          @apply relative hidden items-center justify-center xl:flex;
        }
        .menu-item {
          @apply flex h-[34px] items-center px-4 font-ibm text-[15px] font-medium
            leading-[19.5px] tracking-[-0.3px] hover:bg-black-100 hover:text-black;
        }
        .menu-item.active,
        .menu-item.active:hover {
          @apply border-y border-dashed bg-white text-black;
          border-color: #b0b0b0;
        }
        .menu-item.active svg,
        .menu-item:hover svg {
          @apply fill-black;
        }
        .menu-item + .menu-item {
          margin-left: 8px;
        }
        .menu-item.left {
          @apply absolute left-0 top-1/2 translate-y-[-50%];
        }
      `}</style>
    </div>
  )
}

export default Menu
